import React from "react";
import "./CarModel.css";
import { Link } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Car from "../Car/Car";

const carModel = props => (
  <Grid container spacing={4} style={{ textAlign: "left", marginTop: "5px" }}>
    <Grid item xs={12} className="CarModelTitleDiv">
      <div className="CarModelTitle">{props.name}</div>
    </Grid>

    <Grid item xs={12} sm={3}>
      <Car
        modelName={props.name}
        version={"1.8 Se-g Cvt"}
        price={"$1.200.577"}
        image={"/img/cars/corolla-gray.png"}
        version2={"XLS"}
        motor={"1.5"}
        tipo={"Hatchback"}
        color={"Grid"}
        year={"2019"}
        gear={"Manual"}
        chasis={"CHASIS N° BBCLCRFJK9653003"}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <Car
        modelName={props.name}
        version={"1.8 Se-g Cvt"}
        price={"$1.200.577"}
        image={"/img/cars/corolla-gray.png"}
        version2={"XLS"}
        motor={"1.5"}
        tipo={"Hatchback"}
        color={"Grid"}
        year={"2019"}
        gear={"Manual"}
        chasis={"CHASIS N° BBCLCRFJK9653003"}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <Car
        modelName={props.name}
        version={"1.8 Se-g Cvt"}
        price={"$1.200.577"}
        image={"/img/cars/corolla-gray.png"}
        version2={"XLS"}
        motor={"1.5"}
        tipo={"Hatchback"}
        color={"Grid"}
        year={"2019"}
        gear={"Manual"}
        chasis={"CHASIS N° BBCLCRFJK9653003"}
      />
    </Grid>
    <Grid item xs={12} sm={3}>
      <Car
        modelName={props.name}
        version={"1.8 Se-g Cvt"}
        price={"$1.200.577"}
        image={"/img/cars/corolla-gray.png"}
        version2={"XLS"}
        motor={"1.5"}
        tipo={"Hatchback"}
        color={"Grid"}
        year={"2019"}
        gear={"Manual"}
        chasis={"CHASIS N° BBCLCRFJK9653003"}
      />
    </Grid>
  </Grid>
);

export default carModel;
